import axios from 'axios';

export const getSectionDefault = (id) => `/secciones-default/${id}`;

const { RAZZLE_API_MARCA_BLANCA } = process.env;

export const getSectionDefaultById = (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios.get(`${RAZZLE_API_MARCA_BLANCA}${getSectionDefault(id)}`, config);
};
